import moment, { Moment } from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD';

export type StaySelectionErrorKey =
    | 'rooms_page_error_invalid_move_in_date'
    | 'rooms_page_error_invalid_stay_duration';

interface ValidateStaySelectionParams {
    moveInDate: string | null;
    duration: string | null;
    moveOutDate?: string;
    minimumStayDuration: number;
}

export const getMaximumStayDuration = (moveInDate: Moment, moveOutDate: Moment) =>
    moveOutDate.diff(moveInDate, 'week');

export const validateStaySelection = ({
    moveInDate,
    duration,
    moveOutDate,
    minimumStayDuration,
}: ValidateStaySelectionParams): StaySelectionErrorKey | null => {
    if (!moveInDate || !duration || !moveOutDate) {
        return null;
    }

    const parsedMoveInDate = moment(moveInDate, DATE_FORMAT, true);
    const parsedMoveOutDate = moment(moveOutDate);

    if (
        !parsedMoveInDate.isValid() ||
        !parsedMoveOutDate.isValid() ||
        parsedMoveInDate.isBefore(moment(), 'day')
    ) {
        return 'rooms_page_error_invalid_move_in_date';
    }

    const maximumStayDuration = getMaximumStayDuration(parsedMoveInDate, parsedMoveOutDate);
    const stayDuration = Number(duration);

    if (
        !Number.isInteger(stayDuration) ||
        stayDuration < minimumStayDuration ||
        stayDuration > maximumStayDuration
    ) {
        return 'rooms_page_error_invalid_stay_duration';
    }

    return null;
};
